module.exports = __webpack_public_path__ + "img/6valvulas.5f6bc0b9.jpg";